module.exports = __webpack_public_path__ + "static/img/banner_img4.3b77f76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/banner_img4.png
// module id = 4Vpf
// module chunks = 0